import { render, staticRenderFns } from "./CenterMiddle.vue?vue&type=template&id=9aebd56e&"
import script from "./CenterMiddle.vue?vue&type=script&lang=js&"
export * from "./CenterMiddle.vue?vue&type=script&lang=js&"
import style0 from "./CenterMiddle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports